import { Database, Search, PanelLeftOpen, Plus, FileCode2, type LucideIcon } from 'lucide-react';

interface CollapsedStripProps {
  onExpand: () => void;
}

export function CollapsedStrip({ onExpand }: CollapsedStripProps) {
  return (
    <div className="h-full flex flex-col items-center py-2 gap-1">
      <StripButton icon={PanelLeftOpen} title="Expand sidebar (Cmd+B)" onClick={onExpand} />
      <div className="w-5 border-t border-subtle my-1" />
      <StripButton icon={Database} title="Connections" />
      <StripButton icon={FileCode2} title="Saved Queries" />
      <div className="flex-1" />
      <StripButton icon={Plus} title="New Connection" />
      <StripButton icon={Search} title="Search" />
    </div>
  );
}

function StripButton({
  icon: Icon,
  title,
  onClick,
}: {
  icon: LucideIcon;
  title: string;
  onClick?: () => void;
}) {
  return (
    <button
      className="w-7 h-7 flex items-center justify-center rounded-sm text-text-muted hover:text-text-secondary hover:bg-dbgo-tab-hover transition-colors"
      title={title}
      onClick={onClick}
    >
      <Icon size={16} />
    </button>
  );
}
